import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Utilities_ds_configurations_gridService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }


  public async getList($inParams: { application_name?: string, user_name?: string, name?: string, full_text_search?: string, string_1?: string, string_2?: string, string_3?: string, $top?: number, $skip?: number, $orderby?: { column: ('configuration_id' | 'application_name' | 'user_name' | 'name' | 'value' | 'notes' | 'string_1' | 'string_2' | 'string_3' | 'created_by' | 'created_on' | 'modified_by' | 'modified_on' | 'date_number'), order: ('asc' | 'desc') }[], $filter?: { operator: ('and' | 'or'), operands: { numberFilters?: { column: ('date_number'), operation: ('equals' | 'notEqual' | 'empty' | 'lessThan' | 'lessThanOrEqual' | 'greaterThan' | 'greaterThanOrEqual'), value: number }[], numberMultiFilters?: { column: ('date_number'), operation: ('in' | 'notIn'), value: number[] }[], stringFilters?: { column: ('configuration_id' | 'application_name' | 'user_name' | 'name' | 'value' | 'notes' | 'string_1' | 'string_2' | 'string_3' | 'created_by' | 'modified_by'), operation: ('equals' | 'notEqual' | 'empty' | 'contains' | 'notContains' | 'startsWith' | 'endsWith' | 'blank' | 'notBlank'), value: string }[], stringMultiFilters?: { column: ('configuration_id' | 'application_name' | 'user_name' | 'name' | 'value' | 'notes' | 'string_1' | 'string_2' | 'string_3' | 'created_by' | 'modified_by'), operation: ('in' | 'notIn'), value: string[] }[], dateFilters?: { column: ('created_on' | 'modified_on'), operation: ('equals' | 'notEqual' | 'empty' | 'lessThan' | 'lessThanOrEqual' | 'greaterThan' | 'greaterThanOrEqual'), value: string }[], operator: ('and' | 'or') }[] } }): Promise<{ result?: { configuration_id?: string, application_name?: string, user_name?: string, name?: string, value?: string, notes?: string, string_1?: string, string_2?: string, string_3?: string, created_by?: string, created_on?: string, modified_by?: string, modified_on?: string, date_number?: number }[], totalCount?: number }> {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { application_name?: string, user_name?: string, name?: string, full_text_search?: string, string_1?: string, string_2?: string, string_3?: string, $keys: string[] }): Promise<{ result?: { configuration_id?: string, application_name?: string, user_name?: string, name?: string, value?: string, notes?: string, string_1?: string, string_2?: string, string_3?: string, created_by?: string, created_on?: string, modified_by?: string, modified_on?: string, date_number?: number }[] }> {
    const $missingRequiredInParams = [];
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

    
    hasMissingRequiredInParams($inParams: { 
      application_name?: string, user_name?: string, name?: string, full_text_search?: string, string_1?: string, string_2?: string, string_3?: string    }) {
      return false;
    }
}
